import { MenuStoreService } from '@argalis-apps/angular-services';
import { Router } from '@angular/router';
import { AuthService } from './../../../../auth/services/auth/auth.service';
import { CalendarService } from './../../../services/calendar/calendar.service';
import { Component, Input, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { PanelBarExpandMode, PanelBarItemModel } from '@progress/kendo-angular-layout';
import { DemandeEncadrementService } from '../../../services/demande-encadrement/demande-encadrement.service';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { MUser } from '@argalis-apps/models';
import { SelectorService } from '../../../services/selector/selector.service';

@Component({
  selector: 'ags-bloc-info',
  templateUrl: './bloc-info.component.html',
  styleUrls: ['./bloc-info.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BlocInfoComponent implements OnInit {
  @Input('idSP')
  set _idSP(value: number) {
    if (value) {
      this.idSP = value;
      this.idIndispo = void 0;
    }
  }

  @Input('idIndispo')
  set _idIndispo(value: number) {
    if (value) {
      this.idSP = void 0;
      this.idIndispo = value;
    }
  }

  @Input()
  set dateClicked(value: any) {
    if (value) {
      const previousDateClicked = JSON.parse(JSON.stringify(this._dateClicked));
      this._dateClicked = value;
      const dateRequested = moment(value).format('YYYY/DD/MM');
      const previousDateRequested = moment(previousDateClicked).format('YYYY/DD/MM');
      if (dateRequested.toString() !== previousDateRequested.toString()) {
        this.isHidden = true;
        this.objectLoaded = {};
        this.getInfos();
      } else {
        setTimeout(() => this.expandInfo());
      }
    }
  }
  public idSP: number;
  public idIndispo: number;
  private _dateClicked: Date = new Date(); // par défaut, la date du jour
  public expandMode: number = PanelBarExpandMode.Single;
  public listeIndispo: any = [];
  public test: any = [];
  public dateSession = 'Date du jour';
  public isHidden = true;
  private isLoadedSubject = new Subject<any>();
  private isLoadedObs;
  private objectLoaded = {};
  public userConnected: MUser.CUser;
  public bOst: boolean;
  public infoJour: PanelBarItemModel[] = [
    {
      id: '1',
      title: 'MES FORMATIONS',
      focused: true,
      selected: false,
      disabled: false,
      icon: null,
      iconClass: null,
      children: null,
      imageUrl: null,
      expanded: null,
      content: null,
    },
    {
      id: '2',
      title: 'session',
      focused: false,
      selected: false,
      disabled: false,
      icon: null,
      iconClass: null,
      children: null,
      imageUrl: 'statut-2',
      content: {
        id: 42,
        urlAccept:
          'https://back.argalis.fr/api/validationsession/intervenant/argalis_recette/1Vso41tt6oTK4YE-uTx9N-jZ/false/true',
        urlRefuse:
          'https://back.argalis.fr/api/validationsession/intervenant/argalis_recette/1Vso41tt6oTK4YE-uTx9N-jZ/false/false',
        valider: null,
        validation_manuelle: null,
        mail_envoi: null,
        type: 'session',
        session: 'qweqwe',
        produit: 'test01',
        client: 'test01',
        date: new Date(),
        intervention: [
          { heureDebut: 'test01', heureFin: 'test01', soustraitant: 'test01', sites: 'test01' },
          { heureDebut: 'test01', heureFin: 'test01', soustraitant: 'test01', sites: 'test01' }
        ]
      },
      expanded: true
    }
  ];

  constructor(
    private calendarService: CalendarService,
    private authService: AuthService,
    private router: Router,
    private menuStoreService: MenuStoreService,
    private demandeEncadrement: DemandeEncadrementService,
    private renderer: Renderer2,
    private selectorService: SelectorService
  ) {
    this.isLoadedObs = this.isLoadedSubject.asObservable();
    this.userConnected = this.authService.userConnected || null;
  }

  ngOnInit() {
    this.bOst = ((this.userConnected || ({} as any)).userInfo || ({} as any)).b_ost;
    this.isLoadedSubject.subscribe(data => {
      this.objectLoaded[data] = true;
      if (Object.keys(this.objectLoaded).length > 2) {
        this.expandInfo();
        this.isHidden = false;
      }
    });
    this.getCssColor();
    this.getInfos();
  }

  getInfos() {
    //Ne pas supprimer: Pas besoin des indispo et encadrement pour l'instant donc commenté
    this.infoIndispo();
    this.infoEncadrement();
    this.infoSession();
  }

  getCssColor() {
    this.selectorService.getListStatutSession().subscribe(statut_session => {
      // TODO: appliquer bonne couleurs css qui correspondent à la BDD ici
    });
  }

  expandInfo() {
    if (this.idSP) {
      // si c'est une session, on rétrécie les indispo et cherche la session cliquée
      this.infoJour = this.infoJour.map((info: any) => {
        if (info && info.content) {
          if (info.content.type === 'session') {
            const isTheOneToExpand = (info.content.intervention || []).find((spi: any) => {
              if (!spi) return false;
              return Number(spi.idsp) === Number(this.idSP);
            });
            info.expanded = !!isTheOneToExpand;
          } else if (info.content.type === 'indispo') {
            info.expanded = false;
          } else if (info.content.type === 'encadrement') {
            const isTheOneToExpand = (info.content.planning || []).find((sp: any) => {
              if (!sp) return false;
              return Number(sp.idsp) === Number(this.idSP);
            });
            info.expanded = isTheOneToExpand;
          }
        }
        return info;
      });
    } else if (this.idIndispo) {
      // si c'est une indispo, on rétrécie les sessions et cherche l'indispo cliquée
      this.infoJour = this.infoJour.map((info: any) => {
        if (info && info.content) {
          if (info.content.type === 'session' || info.content.type === 'encadrement') {
            info.expanded = false;
          } else if (info.content.type === 'indispo') {
            const isTheOneToExpand = info.id === this.idIndispo;
            info.expanded = isTheOneToExpand;
          } else if (info.content.type === 'encadrement') {
            info.expanded = false;
          }
        }
        return info;
      });
    }
  }

  infoSession() {
    const idIntervenant = ((this.userConnected || ({} as any)).userInfo || ({} as any)).id;
    this.calendarService.getSession(idIntervenant, this._dateClicked, this.bOst).subscribe(
      (value: Object) => {
        const infoSession = value as any[];
        this.infoJour = this.infoJour.filter(info => ((info || ({} as any)).content || ({} as any)).type !== 'session');
        if (infoSession && infoSession.length) {
          [...infoSession].reverse().forEach((elt, i) => {
            const newSession: PanelBarItemModel = {
              id: i.toString(),
              focused: false,
              selected: false,
              icon: null,
              iconClass: null,
              disabled: false,
              children: null,
              title: 'session',
              imageUrl: 'statut-2',
              content: {
                id: 42,
                urlAccept:
                  'https://back.argalis.fr/api/validationsession/intervenant/argalis_recette/1Vso41tt6oTK4YE-uTx9N-jZ/false/true',
                urlRefuse:
                  'https://back.argalis.fr/api/validationsession/intervenant/argalis_recette/1Vso41tt6oTK4YE-uTx9N-jZ/false/false',
                valider: null,
                validation_manuelle: null,
                mail_envoi: null,
                type: 'session',
                session: 'qweqwe',
                produit: 'test01',
                client: 'test01',
                date: new Date(),
                intervention: [{ heureDebut: 'test01', heureFin: 'test01', soustraitant: 'test01', sites: 'test01' }]
              },
              expanded: this.idSP ? false : i === 0
            };
            newSession.title = elt.reference;
            newSession.imageUrl = `${elt.statut}${i}`;
            newSession.content.id = elt.id;
            newSession.content.valider = elt.b_valider;
            newSession.content.validation_manuelle = elt.b_validation_manuelle;
            newSession.content.mail_envoi = elt.b_mail_envoi;
            newSession.content.session = elt.reference;
            newSession.content.produit = elt.libelle;
            newSession.content.client = elt.nom;
            newSession.content.urlAccept = elt.urlAccept;
            newSession.content.urlRefuse = elt.urlRefuse;
            const intervention = [];
            for (const sp of elt.planning) {
              newSession.content.date = sp.date;
              const subIntervention = {
                heureDebut: sp.heuredebut.substring(0, 5),
                heureFin: sp.heurefin.substring(0, 5),
                soustraitant: sp.soustraitant,
                formateur: sp.formateur.trim() ? sp.formateur : void 0,
                site: sp.site,
                site_adresse: sp.site_adresse,
                site_cp: sp.site_cp,
                site_ville: sp.site_ville,
                idsp: sp.idsp,
                dateSession: sp.date
              };
              intervention.push(subIntervention);
            }
            newSession.content.intervention = intervention;

            this.infoJour.splice(1, 0, newSession);
            setTimeout(() => {
              const imagesVoid = document.querySelectorAll(`img[src='${elt.statut}${i}'].k-image`);
              const chips: any = document.createElement('span');
              chips.classList.add('uk-label');
              chips.classList.add('uk-margin-auto-left');
              switch (elt.statutcouleur) {
                case 'statut-1':
                  chips.classList.add('statut-1');
                  break;
                case 'statut-2':
                  chips.classList.add('statut-2');
                  break;
                case 'statut-3':
                  chips.classList.add('statut-3');
                  break;
                case 'statut-4':
                  chips.classList.add('statut-4');
                  break;
                case 'statut-5':
                  chips.classList.add('statut-5');
                  break;
                case 'statut-6':
                  chips.classList.add('statut-6');
                  break;
                case 'statut-7':
                  chips.classList.add('statut-7');
                  break;
                default:
              }
              chips.append(`${elt.statutcode}`);
              if (imagesVoid && imagesVoid.length) imagesVoid[0].parentElement.append(chips);
            });
          });
        }
        setTimeout(() => this.isLoadedSubject.next('infoSession'));
      },
      () => {
        this.isLoadedSubject.next('infoSession');
      }
    );
  }

  getDemandes(demandeList: any[]) {
    this.menuStoreService.emitNotificationNumber(Number(demandeList.length || 0));
  }

  changeRoute(idDetails: number) {
    this.router.navigate([`/demandes/details/${idDetails}`]);
  }

  infoIndispo() {
    const idIntervenant = ((this.userConnected || ({} as any)).userInfo || ({} as any)).id;
    this.calendarService.getIndispo(idIntervenant, this._dateClicked).subscribe(
      (infoIndispo: any) => {
        this.infoJour = this.infoJour.filter(info => ((info || ({} as any)).content || ({} as any)).type !== 'indispo');
        if (infoIndispo && infoIndispo.length) {
          for (const elmnt of infoIndispo) {
            const newIndispo: any = {
              title: 'indispo',
              imageUrl: `indispo`,
              id: 0,
              content: {
                type: 'indispo',
                dateDebut: new Date(),
                dateFin: new Date(),
                motif: ''
              }
            };
            newIndispo.id = Number(elmnt.id);
            newIndispo.title = (elmnt || ({} as any)).titre || 'Formateur';
            newIndispo.imageUrl = `indispo${elmnt.id}`;
            newIndispo.content.type = 'indispo';
            newIndispo.content.dateDebut = (elmnt || {}).date_debut
              ? moment(new Date(Number((elmnt || ({} as any)).date_debut)).toISOString()).format('DD/MM/YYYY HH:mm')
              : '';
            newIndispo.content.dateFin = (elmnt || {}).date_fin
              ? moment(new Date(Number((elmnt || ({} as any)).date_fin)).toISOString()).format('DD/MM/YYYY HH:mm')
              : '';
            newIndispo.content.motif = ((elmnt || ({} as any)).details || ({} as any)).motiftext || 'Autre';
            this.infoJour.push(newIndispo);
            setTimeout(() => {
              const imagesVoid = document.querySelectorAll(`img[src='indispo${elmnt.id}'].k-image`);
              const chips: any = document.createElement('span');
              chips.classList.add('uk-label');
              chips.classList.add('uk-margin-auto-left');
              chips.classList.add('statut-17');
              chips.append(`INDISPO`);
              if (imagesVoid && imagesVoid.length) imagesVoid[0].parentElement.append(chips);
            });
          }
        }
        this.isLoadedSubject.next('infoIndispo');
      },
      () => {
        this.isLoadedSubject.next('infoIndispo');
      }
    );
  }

  infoEncadrement() {
    const idIntervenant = ((this.userConnected || ({} as any)).userInfo || ({} as any)).id;
    this.demandeEncadrement.getByDate(idIntervenant, this._dateClicked).subscribe(
      (list: any) => {
        this.infoJour = this.infoJour.filter(
          info => ((info || ({} as any)).content || ({} as any)).type !== 'encadrement'
        );
        if (list && list.length) {
          for (const session of list) {
            const newEncadrement: any = {
              title: 'Encadrements',
              imageUrl: 'encadrement',
              content: {
                type: 'encadrement',
                id: 12,
                dateValid: '12/12/2019', // date format dd/MM/YYYY
                title: 'Calculs et fonctionnalités avancées sous Excel 2001',
                referenceProduit: 'PRT-00026',
                referenceSession: 'SES-170564',
                referenceInterne: 'Excel N2 Paris',
                dateBegin: '11/12/2019',
                dateEnd: '12/12/2019',
                lieuName: 'Novotel Paris-Les-Halles',
                lieuAddress: '8 place Marguerite de Navarre, 75001 Paris',
                nameResponsible: 'Hélène DURAND',
                urlAccept:
                  'https://back.argalis.fr/api/validationsession/intervenant/argalis_recette/1Vso41tt6oTK4YE-uTx9N-jZ/false/true',
                urlRefuse:
                  'https://back.argalis.fr/api/validationsession/intervenant/argalis_recette/1Vso41tt6oTK4YE-uTx9N-jZ/false/false',
                valider: null,
                validation_manuelle: null,
                planning: [{ idsp: 0 }]
              }
            };
            newEncadrement.title = session.referenceSession || session.title;
            newEncadrement.imageUrl = `encadr${session.id}`;
            newEncadrement.content.id = session.id;
            newEncadrement.content.dateValid = session.dateValid;
            newEncadrement.content.title = session.title;
            newEncadrement.content.title = session.title;
            newEncadrement.content.referenceProduit = session.referenceProduit;
            newEncadrement.content.referenceInterne = session.referenceInterne;
            newEncadrement.content.referenceSession = session.referenceSession;
            newEncadrement.content.dateBegin = session.dateBegin;
            newEncadrement.content.dateEnd = session.dateEnd;
            newEncadrement.content.lieuName = session.lieuName;
            newEncadrement.content.lieuAddress = session.lieuAddress;
            newEncadrement.content.nameResponsible = session.nameResponsible;
            newEncadrement.content.urlAccept = session.urlAccept;
            newEncadrement.content.urlRefuse = session.urlRefuse;
            newEncadrement.content.planning = session.planning;
            this.infoJour.push(newEncadrement);
            setTimeout(() => {
              const imagesVoid = document.querySelectorAll(`img[src='encadr${session.id}'].k-image`);
              const chips: any = document.createElement('span');
              chips.classList.add('uk-label');
              chips.classList.add('uk-margin-auto-left');
              chips.classList.add('statut-16');
              chips.append(`ENCADREMENT`);
              if (imagesVoid && imagesVoid.length) imagesVoid[0].parentElement.append(chips);
            });
          }
        }
        setTimeout(() => this.isLoadedSubject.next('infoEncadrement'));
      },
      () => {
        this.isLoadedSubject.next('infoEncadrement');
      }
    );
  }
}
